import {
    IndexTable,
    Badge,
    InlineStack,
    Box,
    Button,
    Thumbnail,
    Spinner,
    Select,
    Icon,
    Tooltip
  } from "@shopify/polaris";
  import { NoteIcon,DeliveryIcon,PersonIcon,ChevronDownIcon } from "@shopify/polaris-icons";
  import React, { Fragment, useState,useMemo } from "react";
  import CustomerInformationModal from "../modal/CustomerInformationModal";
  import BadgeTag from "../common/BadgeTag";
import { reqGetOrderNewTrackingDetail } from "../../../../api";
import OrderTrackingModal from "../modal/OrderTrackingModal";
import InitNotPageContent from '../common/InitNotPageContent';
import InitPageContent from '../common/InitPageContent';
import CommonTableSkeletonItem from "../common/CommonTableSkeletonItem";
import SymbolTake from "../../../../components/SymbolTake";
import _ from "lodash";
  const OrderTable = ({
    selected,
    listData,
    setListData,
    selectableOrders,
    selectedResources,
    allResourcesSelected,
    handleSelectionChange,
    planCurrent,
    getPageData,
    requestParams,
    setSearchLoading,
    loading,
    toastFun,
    handleStoreTabChange
  }) => {
    // 总条数
      const pageMsg = () => {
        let total = listData.count ? listData.count : 0;
        const { page, size } = requestParams;
        const startNum = total > 0 ? (page - 1) * size + 1 : 0;
        const endNum = page * size > total ? total : page * size;
        let text = (
          <div>
            Showing {startNum} - {endNum} of {total} results
            <div className="per_page_footer">
              , at most{" "}
              <div className="per_page_select">
                {" "}
                <Select
                  options={[
                    { label: 10, value: 10 },
                    { label: 20, value: 20 },
                    { label: 30, value: 30 },
                    { label: 50, value: 50 },
                  ]}
                  onChange={(value) => {
                    const calculatedTotalPages = Math.ceil(total / Number(value));
                    if (page > calculatedTotalPages) {
                      // 如果当前页码超出范围，重置为第一页
                      getPageData({ size: Number(value), page: 1 });
                    } else {
                      getPageData({ size: Number(value) });
                    }
                    setSearchLoading(true);
                  }}
                  value={requestParams.size}
                />
              </div>
              per page
            </div>
          </div>
        );
        return text;
    
        // eslint-disable-next-line react-hooks/exhaustive-deps
      };
    
      // 是否存在上一页
      const hasPrevious = useMemo(() => {
        const { page, size } = requestParams;
        let total = listData.count ? listData.count : 0;
    
        const maxPageNum = _.ceil(total / size);
        if (page > 1 && page <= maxPageNum) {
          return loading ? false : true;
        } else if (page === 1) {
          return false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [listData, requestParams, loading]);
    
      // 是否存在下一页
      const hasNext = useMemo(() => {
        const { page, size } = requestParams;
        let total = listData.count ? listData.count : 0;
        const maxPageNum = _.ceil(total / size);
        if (_.inRange(page, 1, maxPageNum)) {
          return loading ? false : true;
        } else if (page === maxPageNum) {
          return false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [listData, requestParams, loading]);
    
      // 上一页
      const handlePrev = () => {
        getPageData({ page: Number(requestParams.page) - 1 });
        setSearchLoading(true);
        handleSelectionChange("page", false, 0);
        if (document) {
          if (document?.documentElement || document?.body) {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
          }
        }
      };
      // 下一页
      const handleNext = () => {
        getPageData({ page: Number(requestParams.page) + 1 });
        setSearchLoading(true);
        handleSelectionChange("page", false, 0);
        if (document) {
          if (document?.documentElement || document?.body) {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
          }
        }
      };
    // 查询物流追踪记录
    const [trackingData,setTrackingData] = useState({
      open:false,
      id:'',
      data:{}
    })
    // 地址
    const [addressData,setAddressData] = useState({
      open:false
    })
    const resourceName = {
      singular: "order",
      plural: "orders",
    };
    const headingData = [
      { id: "1", title: <span>Shopify order number</span> },
      { id: "2", title: <span>Tracking number</span> },
      { id: "3", title: <span>Order Status</span> },
      { id: "4", title: <span>Last update time</span> },
      { id: "5", title: <span>Payment Date</span> },
      { id: "6", title: <span>Customer Information</span> },
      { id: "7", title: <span>Action</span> },
    ];
    const handleCopyText = async (value) => {
      try {
          await navigator.clipboard.writeText(value);
          toastFun('Copy successfulluy')
          // 2秒后重置复制状态
      } catch (err) {
          console.error('复制失败:', err);
      }
      };
    // 时间格式
    function formatTimestamp(timestamp) {
      const date = new Date(timestamp * 1000 + (8 * 3600 * 1000));
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const year = date.getUTCFullYear();
      const month = months[date.getUTCMonth()];
      const day = date.getUTCDate();
      let hours = date.getUTCHours();
      const ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12 || 12; // 转换为12小时制，0转为12
      const minutes = date.getUTCMinutes().toString().padStart(2, "0");
  
      return `${month} ${day}, ${year}, ${hours}:${minutes} ${ampm}`;
    }
    const [childData,setChildData] = useState([]);
    const [isChildLoading,setIsChildLoading] = useState(false);
    // 处理点击事件，切换展开状态
const handleClick = async (item,ind) => {
  if (!planCurrent()) {
    return
  }
  setChildData([])
  if (isChildLoading) {
    return
  }
  if (!planCurrent()) {
    return
  }
  setIsChildLoading(true);
  if (item.show) {
    let newOrders = listData?.list.map((item, index) => {
      if (index === ind) {
        return {
          ...item,
          show: 0,
        };
      }
      return item;
    });
    setListData({
      ...listData,
      list: newOrders,
    });
    setChildData([])
    setIsChildLoading(false);
    return
  }else {
    let newOrders = listData?.list.map((item, index) => {
      if (index === ind) {
        return {
          ...item,
          show: 1,
        };
      }else {
        return {
          ...item,
          show: 0,
        };
      }
    });
    setListData({
      ...listData,
      list: newOrders,
    });
  }
  try {
    let params = {
      dsm_record:item.dsm_record,
      shopify_record:item.shopify_record
    }
    
    let res = await reqGetOrderNewTrackingDetail(params);
    if (res.code === '200') {
      setChildData(res.data.items)
    }
    setIsChildLoading(false);
  } catch (error) {
    
  }
    
  };
  const ChildrenItem = ({data})=>{
    let detail = childData || [];
    let node = '';
    if (detail.length > 0) {
      node = detail.map((item, index) => (<IndexTable.Row
        key={index}
        rowType="child"
        disabled={true}
        onClick={()=>{}}
      >
        <td className="children_content_item" colSpan={9}>
         <Box  className='children_content_item_box' style={{marginLeft:'40px'}}>
          <InlineStack align="space-between" blockAlign="center">
            <Box className='children_content_item_left' >
            <InlineStack blockAlign="center" align="flex-start" gap={200}>
              <Box>
                 <Thumbnail
                    source={item.image_url || NoteIcon}
                    size="small"
                    alt="Black choker necklace"
                  />
              </Box>
              <Box>
                <Box className="children_content_item_left_title" title={item.title}>{item.title}</Box>
                <Box>
                  <InlineStack blockAlign="center" gap={300}>
                    <Box>SKU:{item.sku}</Box>
                    <Box>Price: <SymbolTake price={parseFloat(item.shopify_price).toFixed(2)} shopifyPrice={true}/></Box>
                  </InlineStack>
                </Box>
              </Box>
              </InlineStack>
            </Box>
            <Box className='children_content_item_right'>
              <InlineStack blockAlign="center" gap={200}>
              <Box>
                <Box>Cost: <SymbolTake price={parseFloat(item.price).toFixed(2)} /> x {item.quantity}</Box>
                <Box>Total: <SymbolTake price={parseFloat(item.sku_total).toFixed(2)} /></Box>
              </Box>
              
              </InlineStack>
            </Box>
          </InlineStack>
         </Box>
        </td>
      </IndexTable.Row>
  ))
    }else {
      node =  <IndexTable.Row
      key={'0'}
      rowType="child"
      disabled={true}
      onClick={()=>{}}
    ><td className="children_content_item" style={{paddingLeft:'32px'}} colSpan={10}> 
      <InlineStack blockAlign="center" align="flex-start" gap={500}>
      <Spinner accessibilityLabel="not list" size="small" />
      </InlineStack>
      </td></IndexTable.Row>;
    }
   return data.show ? node : '';
  }
    const rowMarkup = listData?.list?.map((item, ind) => {
      // 1. 制作一个手风琴向下展开的盒子
      // 2. 通过控制是否展开的状态，控制是否显示下面的内容
      // 3. 向下展开时有动画效果，收起时也有动画效果
  
      return (<Fragment key={ind}>
      <IndexTable.Row
            id={item.id}
            key={ind}
            selected={selectedResources.includes(item.id)}
            position={ind}
            onClick={()=>{
              if (addressData.open || trackingData.open) {
                return
              }
              handleClick(item,ind)
            }}
          >
            <IndexTable.Cell className="order_cell_01">
              <Box>
                <Box>
                  <InlineStack gap={100} blockAlign="center">
                    <Box className="order_cell_01_title">{item.order_name}</Box>
                    {item.split_tail >0 ? <Box>
                    <Badge>Split Order{item.split_tail}</Badge>
                    </Box>:''}
                  </InlineStack>
                </Box>
                <Box className="order_cell_01_dsm">DSM order {item.dsm_order_number}</Box>
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_02">
              <Box className='order_cell_02_tracking_number' onClick={()=>{
                if (item.tracking_number) {
                  handleCopyText(item.tracking_number)
                }
              }}>{item.tracking_number ? item.tracking_number : '-'}</Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_03">
              <Box>
                <BadgeTag content={item.order_status} />
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_04">
              <Box>
              <InlineStack gap={100} blockAlign="center">
              <Box>{formatTimestamp(item.updated_time)}</Box>
              </InlineStack>
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_05">
              <Box>
              <Box>{formatTimestamp(item.paid_time)}</Box>
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_06">
               <div className="order_customer_info">
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!planCurrent()) {
                      return;
                    }
                    setAddressData({ ...item, open: true });
                  }}
                  variant="palin"
                  size="micro"
                  loading={false}
                >
                  <Tooltip
                    content={
                      "Click to view customer shipping address and information"
                    }
                  >
                    <InlineStack gap={100} blockAlign="center" wrap={false}>
                      <span>
                        <Icon source={PersonIcon} tone="base" />
                      </span>
                      {item.address_failed ? (
                        <div>
                          <img
                            src="/order_fulfillment/failed_icon.png"
                            alt="dropshipman"
                          />
                        </div>
                      ) : (
                        <span className="order_icon_dwon">
                          <Icon source={ChevronDownIcon} />
                        </span>
                      )}
                    </InlineStack>
                  </Tooltip>
                </Button>
              </div>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_07">
              <Box>
                <InlineStack>
                  <Button icon={DeliveryIcon} onClick={(e)=>{
                    e.stopPropagation();
                    if (!planCurrent()) {
                      return
                    }
                    setTrackingData((prev)=>({
                      id:item.dsm_record,
                      open:true,
                      data:{
                        ...item,
                        split_order:item.split_tail,
                        dsm_order_name:item.dsm_order_number
                      }
                    }))
                  }}>Tracking</Button>
                </InlineStack>
              </Box>
            </IndexTable.Cell>
          </IndexTable.Row>
          <ChildrenItem data={item} />
          </Fragment>
      );
    });
  // 定义参数有效性检查工具函数
const hasValidParams = (params) => {
  if (!params) return false;

  // 需要验证的非空字符串参数
  const stringParams = [
    "order_number",
    "start_time",
    "end_time",
  ];

  // 需要验证的非空数组参数
  const arrayParams = [
    "start_time",
  ];

  // 检查字符串参数
  const hasValidString = stringParams.some(
    (key) => params[key] !== undefined && params[key] !== ""
  );

  // 检查数组参数
  const hasValidArray = arrayParams.some((key) => params[key]?.length > 0);

  return hasValidString || hasValidArray;
};
    const emptyStateMarkup =
    Object.values(listData).length > 0 ? (
      <Box>
        {listData?.list?.length === 0 && (
          <Box>
            {hasValidParams(requestParams) ? (
              <InitNotPageContent data={{q:requestParams.order_number}} />
            ) : (
              <InitPageContent
                isTracking={true}
                selected={selected}
                setNoviceModal={()=>{}}
              />
            )}
          </Box>
        )}
      </Box>
    ) : (
      <CommonTableSkeletonItem />
    );
    return (
      <div className="order_table_box orderTracking_table_box product_table_box">
        <IndexTable
          resourceName={resourceName}
          itemCount={selectableOrders?.length
            ? selectableOrders.length
            : listData?.list?.length
            ? listData?.list?.length
            : 0}
          selectedItemsCount={
            allResourcesSelected ? "All" : selectedResources.length
          }
          selectable={false}
          onSelectionChange={handleSelectionChange}
          headings={headingData}
          emptyState={emptyStateMarkup}
          pagination={{
            label: listData?.list?.length > 0 ? pageMsg() : "",
            hasPrevious: hasPrevious,
            onPrevious: () => {
              handlePrev();
            },
            hasNext: hasNext,
            onNext: () => {
              handleNext();
            },
          }}
        >
          {rowMarkup}
        </IndexTable>
        {addressData.open && <CustomerInformationModal
          setAddressData={setAddressData} 
          open={addressData.open}
          id={addressData?.dsm_record}
          sid={addressData?.shopify_record}
          type={1}
          countryCode={''}
          toastFun={toastFun}
          paymentStatus={'Paid'}
          addressStatus={false}
          getSearchParam={requestParams}
          reloadData={getPageData}
          setListLoading={setSearchLoading}
          />}
        {trackingData.open && <OrderTrackingModal 
        trackingData={trackingData} 
        setTrackingData={setTrackingData}
        toastFun={toastFun}
        handleStoreTabChange={handleStoreTabChange}
        />}
      </div>
    );
  };
  
  export default OrderTable;
  